import React from 'react';
import { MailIcon } from 'lucide-react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/welding';
export function Footer() {
  return <footer id="site-footer" className="border-t border-white/10 bg-charcoal py-12 text-white" data-id="element-42" data-mp="3ggtxuh7dth4p">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-43" data-mp="32pfgsfx1bq0a">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-44" data-mp="36oxwmxa01aw9">
          <div data-id="element-45" data-mp="3ueiknul0eyce">
            <p className="wordmark text-[1.4rem]" data-id="element-46" data-mp="3ug3etj3ewf9q">
              {PRODUCT.wordmarkA} <span className="text-steel-pale" data-id="element-47" data-mp="38h5paxxbklh">{PRODUCT.wordmarkB}</span>
              <sup className="ml-0.5 font-sans text-[0.45em] font-semibold" data-id="element-48" data-mp="36mrefh5qqqd">™</sup>
            </p>
            <p className="mt-2 text-[0.92rem] text-steel-light" data-id="element-49" data-mp="3lggbgrr4gze1">{PRODUCT.descriptor}</p>
          </div>

          <div data-id="element-50" data-mp="3qf9q4ni5awfs">
            <p className="label-tech text-steel-light" data-id="element-51" data-mp="29zgl41oc4umn">Support</p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[0.92rem] text-steel-pale transition-colors duration-150 ease-out hover:text-arc-light focus:outline-none focus-visible:text-arc-light" data-id="element-52" data-mp="29xvqkc20tbos">
              <MailIcon className="h-4 w-4 shrink-0 text-orange" aria-hidden data-id="element-53" data-mp="3gca7d7ohu1db" />
              <span className="break-all" data-id="element-54" data-mp="3v8hqe4o60wr0">{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-1.5 border-t border-white/10 pt-6 text-[0.82rem] text-steel-light sm:flex-row sm:flex-wrap sm:gap-x-4" data-id="element-55" data-mp="3q7txtekag7uo">
          <p data-id="element-56" data-mp="3473nkkfm3xo">© 2026 {PRODUCT.name}. All rights reserved.</p>
          <p data-id="element-57" data-mp="33nna8afjnlr">Commercial build rights included. Digital files may not be shared or resold.</p>
        </div>
      </div>
    </footer>;
}